import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { ButtonV3 } from 'components/ComponentV2';
import { useResponsive } from 'hooks/useResponsive';

import styles from './CreateWithAI.module.scss';

interface CreateWithAIProps {
  onAIButtonClick?: () => void;
}

export const CreateWithAI: React.FC<CreateWithAIProps> = memo(
  ({ onAIButtonClick }: CreateWithAIProps) => {
    const [t] = useTranslation('candidate.profile');
    const screens = useResponsive();
    return (
      <>
        {!screens.sm_desktop_down && (
          <p className={styles.or}>{t('create-with-ai.or')}</p>
        )}
        <ButtonV3
          color="brand"
          className={styles.container}
          onClick={onAIButtonClick}
          startIcon="icon_magic-wand"
          iconSize={screens.sm_desktop_down ? 'xsmallplus' : 'medium'}
        >
          {t('create-with-ai.text')}
        </ButtonV3>
      </>
    );
  }
);

CreateWithAI.displayName = 'CreateWithAI';
